export default {

    apiUrl: 'https://beheer.avecodebondt.nl/api',

    apps: [
        { id: 'mijn-aveco', name: 'Mijn Aveco de Bondt', url: 'https://beheer.avecodebondt.nl' },
        { id: 'monitor', name: 'Monitoringsplatform', url: 'https://omgevingsmonitoring.avecodebondt.nl' },
        { id: 'veldwerkwinkel', name: 'Veldwerkwinkel', url: 'https://veldwerkwinkel.avecodebondt.nl' },
        { id: 'loggers', name: 'Loggerdatabase', url: 'https://loggers.avecodebondt.nl' },
        { id: 'veldwerkdata', name: 'Veldwerkdata', url: 'https://veldwerkdata.avecodebondt.nl' },
    ]
}
